(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9107],{

/***/ 13505:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/notifications",
      function () {
        return __webpack_require__(3020);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74249);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__);




const ContentLoading = (param)=>{
    let { label , fullScreen =false , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const text = label || t("Loading...");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-label": text,
        className: "".concat((_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRoot), " ").concat(fullScreen ? (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRootFullScreen) : "", " ").concat(className).trim(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/images/loading/spinner.svg",
                alt: "",
                width: 64,
                height: 64,
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingSpinner),
                "aria-hidden": "true",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingLabel),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentLoading);


/***/ }),

/***/ 76039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useAndroidDevicePagedData; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95629);
/* harmony import */ var src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82017);
/* harmony import */ var src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26771);




/** INSTALLED_APP 按包名去重，兼容 bundleid / bundleId */ function getAppBundleId(item) {
    return (item === null || item === void 0 ? void 0 : item.bundleid) || (item === null || item === void 0 ? void 0 : item.bundleId) || "";
}
function dedupeInstalledApps(items) {
    const seen = new Set();
    const result = [];
    for (const item of items){
        const key = getAppBundleId(item);
        if (key) {
            if (seen.has(key)) continue;
            seen.add(key);
        }
        result.push(item);
    }
    return result;
}
/**
 * Android Cloud / Local 分页列表 Hook，设备切换时重置分页并取消旧请求。
 *
 * @param {Object} options
 * @param {'local'|'cloud'} options.source - 数据源：Local 或 Gcloud
 * @param {string} options.category - 接口 category 参数
 * @param {number} options.limit - 每页条数
 * @returns {{ context: Object|null, data: Array, loading: boolean, total: number, loadNext: Function, reload: Function, setDateRange: Function }}
 */ function useAndroidDevicePagedData(param) {
    let { source , category , limit  } = param;
    const [data, setData] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
    const [total, setTotal] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    const [context, setContext] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const scopeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const revisionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    const pageRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        offset: 0,
        maxNum: false,
        loading: false
    });
    /** @type {React.MutableRefObject<{ startTime: number, endTime: number } | null>} 日期筛选区间（毫秒） */ const dateRangeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const loadPage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async function(offset) {
        let scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : scopeRef.current, revision = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : revisionRef.current;
        if (!scope || pageRef.current.loading || pageRef.current.maxNum) return;
        pageRef.current.loading = true;
        const { context: scopedContext , signal , isCurrent  } = scope;
        const request = source === "local" ? src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__/* .getLocalAndroidAll */ .gH : src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__/* .getGcloudAll */ .U1;
        const params = {
            category,
            offset,
            limit
        };
        if (source === "local") params.deviceUdid = (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_3__/* .readLocalDeviceUdid */ .S)(scopedContext);
        if (source === "cloud" && (scopedContext === null || scopedContext === void 0 ? void 0 : scopedContext.physicalDeviceKey)) {
            params.deviceUdid = scopedContext.physicalDeviceKey;
        }
        // 日期筛选走接口：不筛选时不传，请求与改动前一致
        const range = dateRangeRef.current;
        if (range) {
            if (range.startTime != null) params.startTime = range.startTime;
            if (range.endTime != null) params.endTime = range.endTime;
        }
        try {
            var ref;
            const response = await request({
                username: source === "local" ? (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_3__/* .readUserEmail */ .t)() : (scopedContext === null || scopedContext === void 0 ? void 0 : scopedContext.username) || "",
                params
            }, {
                signal
            });
            if (!isCurrent() || revision !== revisionRef.current) return;
            const contents = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.contents;
            if (contents) {
                setData((old)=>{
                    const merged = offset === 0 ? [
                        ...contents
                    ] : [
                        ...old,
                        ...contents
                    ];
                    return category === "INSTALLED_APP" ? dedupeInstalledApps(merged) : merged;
                });
                setTotal(response.data.totalCount || 0);
                pageRef.current.offset = offset;
                if (contents.length < limit) pageRef.current.maxNum = true;
            } else {
                pageRef.current.maxNum = true;
            }
            setLoading(false);
        } catch (error) {
            if (isCurrent() && revision === revisionRef.current && (error === null || error === void 0 ? void 0 : error.code) !== "ERR_CANCELED") {
                ;
                setLoading(false);
            }
        } finally{
            if (isCurrent() && revision === revisionRef.current) pageRef.current.loading = false;
        }
    }, [
        category,
        limit,
        source
    ]);
    // 设备切换：重置分页 state 并从第一页重新请求
    (0,src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_2__/* .useDeviceScopedInit */ .A)((0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((_, scope)=>{
        scopeRef.current = scope;
        revisionRef.current += 1;
        dateRangeRef.current = null;
        pageRef.current = {
            offset: 0,
            maxNum: false,
            loading: false
        };
        setData([]);
        setLoading(true);
        setTotal(0);
        setContext(scope.context);
        loadPage(0, scope, revisionRef.current);
    }, [
        loadPage
    ]));
    const loadNext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        const page = pageRef.current;
        if (!page.maxNum && !page.loading) loadPage(page.offset + limit);
    }, [
        limit,
        loadPage
    ]);
    const reload = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        const scope = scopeRef.current;
        if (!scope) return;
        revisionRef.current += 1;
        pageRef.current = {
            offset: 0,
            maxNum: false,
            loading: false
        };
        setData([]);
        setLoading(true);
        setTotal(0);
        loadPage(0, scope, revisionRef.current);
    }, [
        loadPage
    ]);
    /**
   * 设置日期筛选区间并重新从第一页拉取（区间由接口过滤，不是本地过滤）。
   * @param {{ startTime: number, endTime: number } | null} range - 毫秒时间戳；null 表示清除筛选
   */ const setDateRange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((range)=>{
        dateRangeRef.current = range;
        reload();
    }, [
        reload
    ]);
    return {
        context,
        data,
        loading,
        total,
        loadNext,
        reload,
        setDateRange
    };
}


/***/ }),

/***/ 82017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useDeviceScopedInit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34745);



/**

 * 当前选中设备变化时重新执行初始化逻辑（拉数、重置本地 state 等）。

 * 通过 requestKey 与 AbortSignal 丢弃切换前未完成的异步请求。

 *

 * @param {(deviceUser: string, scope: {

 *   context: Object,

 *   signal: AbortSignal,

 *   isCurrent: () => boolean

 * }) => void} initFn - 设备作用域初始化回调，需 useCallback 包裹

 */ function useDeviceScopedInit(initFn) {
    const deviceUser = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const context = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceContext */ .VQ);
    const requestKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceRequestKey */ .rx);
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(context);
    contextRef.current = context;
    const effectiveDeviceUser = deviceUser || (context === null || context === void 0 ? void 0 : context.accountId) || (context === null || context === void 0 ? void 0 : context.username);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!effectiveDeviceUser) return;
        const controller = new AbortController();
        let active = true;
        const scopedContext = contextRef.current;
        // 仅当 requestKey 仍与当前 Redux 一致时，才应用异步结果
        const isCurrent = ()=>{
            var ref;
            return active && !controller.signal.aborted && ((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) === requestKey;
        };
        initFn(effectiveDeviceUser, {
            context: scopedContext,
            signal: controller.signal,
            isCurrent
        });
        return ()=>{
            active = false;
            controller.abort();
        };
    }, [
        effectiveDeviceUser,
        initFn,
        requestKey
    ]);
}


/***/ }),

/***/ 3020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34745);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15378);
/* harmony import */ var src_hooks_useAndroidDevicePagedData__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76039);
/* harmony import */ var src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31909);
/* harmony import */ var src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74743);











const Notifications = ()=>{
    const { t , locale  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common");
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    const [showData, setShowData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]) //展示数据
    ;
    const [showDate, setShowDate] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false) //展示选择日期框
    ;
    const [selectDate, setSelectDate] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(dayjs__WEBPACK_IMPORTED_MODULE_6___default()().format("YYYY-MM-DD")) //选择的日期
    ;
    const parentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { context , data: allData , loading: isLoading , loadNext , setDateRange  } = (0,src_hooks_useAndroidDevicePagedData__WEBPACK_IMPORTED_MODULE_7__/* .useAndroidDevicePagedData */ .v)({
        source: "local",
        category: "NOTIFICATION",
        limit: 100
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setShowData([]);
        setShowDate(false);
        setSelectDate(dayjs__WEBPACK_IMPORTED_MODULE_6___default()().format("YYYY-MM-DD"));
    }, [
        context === null || context === void 0 ? void 0 : context.requestKey
    ]);
    // 通知按「选中日期」走接口筛选（下面的本地过滤作为兜底）
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!selectDate) return;
        const { startTime , endTime  } = (0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_8__/* .buildTimeParams */ .W2)([
            selectDate,
            selectDate
        ]);
        setDateRange({
            startTime,
            endTime
        });
    }, [
        selectDate,
        context === null || context === void 0 ? void 0 : context.requestKey,
        setDateRange
    ]);
    const dom = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    // 滚动百分比
    const [scroll, setScroll] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    // 获取滚动百分比
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handScroll = ()=>{
            if (dom.current) {
                const { scrollTop , scrollHeight , clientHeight  } = dom.current;
                const progress = scrollTop / (scrollHeight - clientHeight) * 100;
                setScroll(progress.toFixed(0));
            }
        };
        const currentRef = dom.current;
        if (currentRef) {
            currentRef.addEventListener("scroll", handScroll);
        }
        return ()=>{
            if (currentRef) {
                currentRef.removeEventListener("scroll", handScroll);
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // 滚动触发加载
        if (scroll >= 100 && !isLoading) loadNext();
    }, [
        isLoading,
        loadNext,
        scroll
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // 初始加载（showData为空时）
        if (showData.length === 0 && allData.length > 0 && !isLoading) loadNext();
    }, [
        allData.length,
        isLoading,
        loadNext,
        showData.length
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // 计算当天起始时间和结束时间（毫秒）
        const start = dayjs__WEBPACK_IMPORTED_MODULE_6___default()("".concat(selectDate, " 00:00:00")).valueOf();
        const end = dayjs__WEBPACK_IMPORTED_MODULE_6___default()("".concat(selectDate, " 23:59:59")).valueOf();
        // item.time 可能是秒/毫秒时间戳或日期字符串，统一成毫秒再比较
        const newData = allData.filter((item)=>{
            const itemTime = (0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_8__/* .toMillis */ .eq)(item.time);
            return itemTime >= start && itemTime <= end;
        });
        setShowData(newData);
    }, [
        selectDate,
        allData
    ]);
    // 获取当前语种的dayjs
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handleLocale = async ()=>{
            switch(locale){
                case "fr":
                    await __webpack_require__.e(/* import() */ 6023).then(__webpack_require__.t.bind(__webpack_require__, 96023, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_6___default().locale("fr");
                    break;
                case "jp":
                    await __webpack_require__.e(/* import() */ 6831).then(__webpack_require__.t.bind(__webpack_require__, 76831, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_6___default().locale("ja");
                    break;
                case "es":
                    await __webpack_require__.e(/* import() */ 7763).then(__webpack_require__.t.bind(__webpack_require__, 91844, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_6___default().locale("es");
                    break;
                case "de":
                    await __webpack_require__.e(/* import() */ 790).then(__webpack_require__.t.bind(__webpack_require__, 80790, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_6___default().locale("de");
                    break;
                case "it-ch":
                    await __webpack_require__.e(/* import() */ 5551).then(__webpack_require__.t.bind(__webpack_require__, 15551, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_6___default().locale("it");
                    break;
                case "pt":
                    await __webpack_require__.e(/* import() */ 5001).then(__webpack_require__.t.bind(__webpack_require__, 15001, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_6___default().locale("pt");
                    break;
                case "kr":
                    await __webpack_require__.e(/* import() */ 9132).then(__webpack_require__.t.bind(__webpack_require__, 19132, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_6___default().locale("ko");
                    break;
                case "ar":
                    await __webpack_require__.e(/* import() */ 3939).then(__webpack_require__.t.bind(__webpack_require__, 63939, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_6___default().locale("ar");
                    break;
                case "tr":
                    await __webpack_require__.e(/* import() */ 3035).then(__webpack_require__.t.bind(__webpack_require__, 73035, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_6___default().locale("tr");
                    break;
                default:
                    await __webpack_require__.e(/* import() */ 5054).then(__webpack_require__.t.bind(__webpack_require__, 25054, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_6___default().locale("en");
            }
        };
        handleLocale();
    }, [
        locale
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const title = t("Notifications");
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_5__/* .setCurrentTab */ .Lw)(title));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_5__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch,
        t
    ]);
    const button = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "w-[337px] smj:w-full smj:px-2 h-[44px] smjs:my-[15px] smj:mt-5 flex items-center smjs:mr-[58px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: "/image/arrow.svg",
                    width: 24,
                    height: 24,
                    alt: "left",
                    className: "cursor-pointer",
                    onClick: ()=>handleChangeDay("reduce")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-[257px] h-[44px] smj:w-[calc(100%-68px)] mx-4 smj:mx-[10px] bg-[#F2F3F5] rounded-[8px] relative cursor-pointer",
                    ref: parentRef,
                    onClick: (e)=>{
                        e.stopPropagation();
                        setShowDate(!showDate);
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: "/image/calendar.svg",
                            width: 24,
                            height: 24,
                            alt: "calendar",
                            className: "absolute top-[10px] left-3"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-center text-[14px] leading-[22px] my-[11px] text-[#484B60]",
                            children: selectDate
                        }),
                        showDate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            open: showDate,
                            onOpenChange: setShowDate,
                            value: selectDate ? dayjs__WEBPACK_IMPORTED_MODULE_6___default()(selectDate) : null,
                            format: "YYYY-MM-DD",
                            getPopupContainer: ()=>parentRef.current,
                            className: "absolute w-full h-full top-0 left-0 right-0 opacity-0 cursor-pointer",
                            onChange: (date, dateString)=>{
                                setSelectDate(dateString);
                                setShowDate(false);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: "/image/arrow.svg",
                    width: 24,
                    height: 24,
                    alt: "right",
                    className: "cursor-pointer rotate-180",
                    onClick: ()=>handleChangeDay("add")
                })
            ]
        });
    const handleChangeDay = (type)=>{
        let newDate;
        if (type == "add") newDate = dayjs__WEBPACK_IMPORTED_MODULE_6___default()(selectDate).add(1, "day").format("YYYY-MM-DD");
        else if (type == "reduce") newDate = dayjs__WEBPACK_IMPORTED_MODULE_6___default()(selectDate).subtract(1, "day").format("YYYY-MM-DD");
        setSelectDate(newDate);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full bg-white !h-[calc(var(--vh2)*100-215px)] smj:!h-[calc(var(--vh2)*100-90px)] [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] overflow-hidden relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full h-[75px] smj:h-auto flex smj:flex-col smjs:justify-between smjs:border-b-[1px] smjs:border-[#E2E2E4]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pl-[32px] smj:p-5 py-[22px] text-[20px] leading-[30px] smj:text-[18px] smj:leading-[26px] font-[600] text-[#282938] smj:border-b-[1px] smj:border-[#E2E2E4]",
                        children: t("Timeline View")
                    }),
                    button()
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full !h-[calc(var(--vh2)*100-290px)] smj:!h-[calc(var(--vh2)*100-218px)] overflow-auto p-[32px] smj:px-[10px] smj:py-4 smj:mt-2",
                ref: dom,
                children: showData.map((item, i)=>{
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full h-auto flex",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "!w-[42px] flex-shrink-0 text-[14px] leading-[22px] text-[#2D3045] smj:hidden pt-1",
                                children: dayjs__WEBPACK_IMPORTED_MODULE_6___default()(item.time).format("HH:mm")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col flex-shrink-0 items-center smjs:pl-6 pr-[18px] smj:pr-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: "https://cos.spyx.com/" + (item === null || item === void 0 ? void 0 : item.iconUrl),
                                        width: 42,
                                        height: 42,
                                        alt: "icon",
                                        className: "w-[42px] h-[42px] smj:w-[36px] smj:h-[36px]"
                                    }),
                                    i !== showData.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "border-l border-dashed border-[#BEC2D0] h-[calc(100%-42px)] smj:h-[calc(100%-36px)]"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col pb-[32px] smj:pb-[24px] w-[-webkit-fill-available] ".concat(i == showData.length - 1 && "!pb-0"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center justify-between pt-1",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-[16px] leading-[24px] font-[600] text-[#1B1C2B]",
                                                children: item === null || item === void 0 ? void 0 : item.app
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-[14px] leading-[24px] text-[#787A87] smjs:hidden",
                                                children: dayjs__WEBPACK_IMPORTED_MODULE_6___default()(item.time).format("HH:mm")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mt-2 text-[14px] leading-[22px] text-[#2D3045]",
                                        children: item === null || item === void 0 ? void 0 : item.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mt-1 text-[14px] leading-[22px] text-[#2D3045]",
                                        children: item === null || item === void 0 ? void 0 : item.text
                                    })
                                ]
                            })
                        ]
                    }, i);
                })
            }),
            isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
            }) : null,
            allData.length > 0 || isLoading || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center px-5 absolute inset-0 flex justify-center items-center pointer-events-none",
                children: [
                    t("It appears theres no data to show here yet"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    t("If data exists it may take up to 1 hour to download and appear"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    t("We suggest checking back in a little while")
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Notifications);


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentLoadingRoot":"ContentLoading_contentLoadingRoot__ypzGH","contentLoadingRootFullScreen":"ContentLoading_contentLoadingRootFullScreen__ZmB8e","contentLoadingSpinner":"ContentLoading_contentLoadingSpinner__4vCxU","content-loading-spin":"ContentLoading_content-loading-spin__K0YUP","contentLoadingLabel":"ContentLoading_contentLoadingLabel__S0w79"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1033,8914,3368,1675,5378,9774,2888,179], function() { return __webpack_exec__(13505); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);